import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";
import FormInputs from "../../../../../../components/UI/FormInputs";
 
const NewYesOrNoFields = ({
    showNotes,
    notes,
    options = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }, { label: 'Not Sure', value: 'Not Sure' }],
    col,
    failedValue,
    list,
    label,
    appendClass,
    headerAppendClass,
    headerColAppendClass,
    readOnly,
    validation,
    formData,
    changeHandler,
    updateFormData,
    subLabel,
    sublabelStyle,
    ...props
}) => {
 
    // Function to handle bulk update (Header controls)
    const handleBulkUpdate = (value) => {
        if (readOnly) return;
        
        const updatedData = {};
        list.forEach(item => {
            updatedData[item.name] = value;
        });
        updateFormData(updatedData);
    };
    const isAllSelected = (value) => {
        if (!list || list.length === 0) return false;
        return list.every((item) => {
            const itemValue = isSet(formData[item.name], '');
            return itemValue === value;
        });
    };
 
    return (
        <div className={`card sh_basecard border-0 shadow-none h-auto mb-0 ${appendClass}`}>
            
            <div className={`card-header sh_basecardHeader ${headerAppendClass || ''}`.trim()}>
                <div className="row align-items-center">
                    <div className={`col-12 col-md-6 ${headerColAppendClass || ''}`.trim()}>
                        <h6 className="m-0 text-md font-weight-bold">
                            {label}
                        </h6>
                        {subLabel && <label className={`form-label ${sublabelStyle || ''}`.trim()}>
                            {subLabel}
                        </label>}
                        {/* Display extra notes/instructions if provided */}
                        {/* {isSet(notes) && notes.length > 0 && (
                            <small className="text-muted d-block mt-1">
                                {notes.map((n, i) => <span key={i} className="mr-2">{n}</span>)}
                            </small>
                        )} */}
                    </div>
                    
                    {/* Header Bulk Controls (Yes/No/Not Sure) */}
                    <div className="col-12 col-md-6 d-flex exam-dot-resposive-radio-group  justify-content-md-end ">                        
                        {options.map((opt, index) => (
                            <div className="form-check d-flex form-check-inline" key={`header_${index}`} style={{marginRight:"13px"}}>
                                <input
                                    className="form-check-input cursor-pointer"
                                    type="radio"
                                    name={`bulk_update_${label.replace(/\s/g, '')}`} // Unique group name for header
                                    id={`header_opt_${index}_${label.replace(/\s/g, '')}`}
                                    disabled={readOnly}
                                    onChange={() => handleBulkUpdate(opt.value)}
                                    checked={isAllSelected(opt.value)}
                                   
                                />
                                <label
                                    className="form-check-label cursor-pointer"
                                    htmlFor={`header_opt_${index}_${label.replace(/\s/g, '')}`}
                                >
                                    {opt.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
 
            {/* --- Card Body --- */}
            <div className="card-body p-2 sh_basecardBody">
                <div className="row">
                    <div className="col-md-12">
                        {list.map((tData, tIndex) => {
                            const hasError = isSet(validation) && isSet(validation[tData.name], "") !== "";
                            
                            return (
                                <div key={tIndex} className="mb-2 pb-2">
                                    <div className="form-group row mb-0 align-items-start">
                                        {/* Question Label - more width to reduce wrapping */}
                                        <div className="col-12 col-md-8 col-lg-9">                                            
                                            <label className="form-label mb-0">
                                                {tData.label}
                                                {/* Validation Error Message */}
                                                {hasError && (
                                                    <span className="text-danger ml-2 small">
                                                        ({validation[tData.name]})
                                                    </span>
                                                )}
                                            </label>
                                        </div>
 
                                        {/* Radio Options - top-aligned, less horizontal gap */}
                                        <div className="col-12 col-md-5 col-lg-3 exam-dot-resposive-radio-group mt-2 mt-md-0 d-flex justify-content-md-end flex-nowrap">                                            
                                            {options.map((option, optionIndex) => {
                                                const isSelected = (isSet(formData[tData.name], null) === option.value);
                                                
                                                // Handle failed/abnormal value styling (Red background)
                                                let inputStyle = {};
                                                const activeFailedValue = isSet(tData.failedValue) ? tData.failedValue : failedValue;
                                                
                                                if (isSet(activeFailedValue, null) !== null &&
                                                    activeFailedValue.indexOf(option.value) >= 0 &&
                                                    formData[tData.name] === option.value) {
                                                    inputStyle = { backgroundColor: 'red', borderColor: 'red' };
                                                }
 
                                                return (
                                                    <div className="form-check form-check-inline" key={optionIndex}>
                                                        {/* Using FormInputs to maintain existing logic hooks, but styled as requested */}
                                                        <FormInputs
                                                            className="form-check-input"
                                                            type='Radio'
                                                            style={{ ...inputStyle }}
                                                            name={`${tData.name}_${tIndex}`} // Group per question
                                                            id={`radio_${tData.name}_${tIndex}_${optionIndex}`}
                                                            value={isSelected} // FormInputs expects bool for 'checked' logic in some versions, or value match
                                                            readOnly={readOnly}
                                                            onKeyPress={tData.onKeyPress}
                                                            changeHandler={() => changeHandler(tData.name, option.value)}
                                                        />
                                                        {/* The invisible label keeps layout spacing consistent with the HTML provided */}
                                                        <label
                                                            className="form-check-label visible-sm  invisible-sm"
                                                            htmlFor={`radio_${tData.name}_${tIndex}_${optionIndex}`}
                                                        >
                                                            {option.label}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
 
                                    {/* Optional Notes Field (If enabled) */}
                                    {showNotes && (
                                        <div className="row mt-1">
                                            <div className="col-md-12">
                                                <FormInputs
                                                    type="TextArea"
                                                    className="form-control form-control-sm"
                                                    name={tData.notesName || `${tData.name}_notes`}
                                                    id={tData.notesName || `${tData.name}_notes`}
                                                    value={formData[tData.notesName || `${tData.name}_notes`] || ""}
                                                    changeHandler={(value) => changeHandler(tData.notesName || `${tData.name}_notes`, value)}
                                                    readOnly={readOnly}
                                                    placeholder="Add details/notes..."
                                                    rows="2"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
 
NewYesOrNoFields.defaultProps = {
    appendClass: 'mt-0',
    failedValue: null,
    validation: {},
    showNotes: false
};
 
export default NewYesOrNoFields;
 